/* eslint-disable max-len */
export const commonMessages = {
    'Common.action': 'Accion',
    'Common.actions': 'Acciones',
    'Common.active_users': 'Usuarios Activos',
    'Common.add': 'Agregar',
    'Common.add_client': 'Añadir Cliente',
    'Common.add_new_permission': 'Agregar Nuevo Permiso',
    'Common.added': 'Agregado',
    'Common.admin': 'Admin',
    'Common.administrator': 'Administrador',
    'Common.admins': 'Administradores',
    'Common.all': 'Todo',
    'Common.all_applications': 'Todas las Aplicaciones',
    'Common.all_categories': 'Todas las Categorias',
    'Common.all_devices': 'Todos los Dispositivos',
    'Common.all_groups': 'Todos los Grupos',
    'Common.all_time': 'siempre',
    'Common.all_users': 'Todos los Usuarios',
    'Common.application': 'Aplicacacion',
    'Common.application_library': 'Librería de Aplicaciones',
    'Common.application_tag': 'Etiqueta de Aplicación',
    'Common.applicationState': 'Estado de Aplicación',
    'Common.approved': 'Aprovado',
    'Common.assign': 'Asignar',
    'Common.beginner': 'Principiante',
    'Common.brand_name': 'Auvik SaaS Management',
    'Common.breakdown': 'Desglose',
    'Common.bulk_editor': 'Editor Masivo de Aplicaciones',
    'Common.business_owner': 'Dueño de Empresa',
    'Common.business_purpose': 'Propósito de la Empresa',
    'Common.cancel': 'Cancelar',
    'Common.categories': 'Categorias',
    'Common.category': 'Categoria',
    'Common.client_name': 'Cliente',
    'Common.clients': 'Clientes',
    'Common.close': 'Cerrar',
    'Common.color': 'Color',
    'Common.coming_soon': 'Pronto',
    'Common.configuration': 'Configuraciones',
    'Common.configure': 'Configurar',
    'Common.confirm': 'Confirmar',
    'Common.copied': 'Copiado!',
    'Common.copy': 'Copiar',
    'Common.count': 'Contar',
    'Common.create': 'Crear',
    'Common.created': 'Creado',
    'Common.created_by': 'Creado Por',
    'Common.created_for': 'Creado Para',
    'Common.dashboard': 'Panel ',
    'Common.data': 'Data',
    'Common.date': 'Fecha',
    'Common.dateAdded': 'Dia Agregado',
    'Common.day': 'Día ',
    'Common.days_fri': 'Vi',
    'Common.days_mon': 'Lu',
    'Common.days_sat': 'Sa',
    'Common.days_sun': 'Do',
    'Common.days_thu': 'Ju',
    'Common.days_tue': 'Ma',
    'Common.days_wed': 'Mi',
    'Common.default': 'Predeterminado',
    'Common.default_new_permission':
        'Permiso Predeterminado Para Nuevos Usuarios',
    'Common.delete': 'Borrar',
    'Common.delta': 'Delta',
    'Common.deployment': 'Implementación',
    'Common.deployment_overview': 'Descripción General de la Implementación',
    'Common.deployment_scripts': 'Guiones de Implementación',
    'Common.description': 'Descripcion',
    'Common.device_hostname': 'Anfitrión',
    'Common.devices': 'Dispositivos',
    'Common.devices_without_sso': 'Dispositivos sin SSO',
    'Common.disable': 'Deshabilitar',
    'Common.disabled': 'deshabilitar',
    'Common.during': 'Durante',
    'Common.edit': 'Editar',
    'Common.email': 'Correo electronico',
    'Common.email_settings': 'Ajustes de correo electrónico',
    'Common.email_subscribed':
        'Recibir Correos Electrónicos de Auvik SaaS Management',
    'Common.email_subscriptions': 'Subscipciones de correo electrónico',
    'Common.enable': 'Habilitar',
    'Common.enabled': 'habilitar',
    'Common.error': 'Ha ocurrido un error interno',
    'Common.exclude_unapproved_applications':
        'Excluir Aplicaciones No Autorizadas',
    'Common.existing_user': 'Usuarios Existentes',
    'Common.expert': 'Experto',
    'Common.expertise': 'Experto',
    'Common.experts': 'Expertos',
    'Common.field': 'campo',
    'Common.first': 'Primer',
    'Common.first_name': 'Primer Nombre',
    'Common.global_administration': 'Administración Global',
    'Common.go': 'Ir',
    'Common.group': 'Grupo',
    'Common.groups': 'Grupos',
    'Common.intermediate': 'Experto',
    'Common.job_title': 'Titúlo',
    'Common.just_updated': 'Recien Actualizado',
    'Common.last_name': 'Apellido',
    'Common.last_used': 'Última sesión',
    'Common.last_user_added': 'Ultimo Usuario Agregado <Date />',
    'Common.lastUpdated': 'Última actualización',
    'Common.lastUpdateValue': 'Última actualización: {{value}}',
    'Common.license_breakdown_usage_last_week':
        'Uso de licencia la semana pasada',
    'Common.license_count': 'Cantidad de Licencias',
    'Common.license_overview_usage_last_week':
        'Uso de licencia la semana pasada',
    'Common.license_state': 'Estado de uso de la licencia',
    'Common.lifecycleStage': 'Estado',
    'Common.link': 'Enlace',
    'Common.loading': 'Cargando',
    'Common.login': 'iniciar sesión',
    'Common.logout': 'cerrar sesión',
    'Common.macAddress': 'Dirección MAC',
    'Common.main_settings': 'Ajustes',
    'Common.manage': 'Administrar',
    'Common.manage_applications': 'Manejo de Aplicaciones',
    'Common.managed': 'Administrado ',
    'Common.managed_applications': 'Aplicaciones Gestionadas',
    'Common.managing': 'Gerete',
    'Common.month': 'Mes',
    'Common.multiple_applications': 'Aplicaciones Multiples',
    'Common.name': 'Nombre',
    'Common.no_users': 'Sin Usuarios',
    'Common.none': 'Nada',
    'Common.normal': 'Normal',
    'Common.not_configured': 'Sin configuración',
    'Common.or': 'ó',
    'Common.organization': 'Organización',
    'Common.organizations': 'Organizaciones',
    'Common.os': 'Sistema Operativo',
    'Common.overview': 'Visión General ',
    'Common.partner': 'Socio',
    'Common.partner_dashboard': 'Panel de Socios',
    'Common.pause': 'Pausa',
    'Common.percent': 'Porcentaje',
    'Common.percentage': 'Porcentaje ',
    'Common.permission': 'Permiso',
    'Common.permission_added': 'Permiso Agregado',
    'Common.permission_enabled': 'Permiso Habilitado',
    'Common.permission_updated': 'Permiso Actualizado',
    'Common.permissions': 'Permisos',
    'Common.product_experts': 'Expertos en Producto',
    'Common.purpose': 'Proposito',
    'Common.quick': 'Rápido',
    'Common.quick_links': 'Enlaces Rapidos ',
    'Common.quick_start_guide': 'Guía de Inicio Rápido',
    'Common.related_app_usage': 'Uso de Aplicaciones Relacionadas',
    'Common.related_app_users': 'Usuarios Utilizando Aplicaciones Relacionadas',
    'Common.remove': 'Remover',
    'Common.removed': 'Removido',
    'Common.report': 'Reporte',
    'Common.reports': 'Reportes',
    'Common.reports_ran': 'Reporte Emitido',
    'Common.resume_session': 'Reanudar Sesión',
    'Common.risk': 'Riesgo',
    'Common.run': 'Correr',
    'Common.run_reports': 'Emitir Reporte',
    'Common.save': 'Guardar',
    'Common.save_changes': 'Guardar Cambios',
    'Common.save_settings': 'Guardar Ajustes',
    'Common.search': 'Buscar',
    'Common.select.lifecycleStage': 'Seleccionar Estado',
    'Common.select_application': 'Seleccionar Aplicación',
    'Common.select_applications': 'Selecione Aplicación',
    'Common.select_categories': 'Seleccione Categorias',
    'Common.select_tags': 'Seleccionar Etiquetas',
    'Common.selectAnOption': 'Seleccione una opción',
    'Common.selection': 'Selección',
    'Common.settings': 'Ajustes',
    'Common.setup': 'Configuaración',
    'Common.slogan': 'OPTIMICE SU INVERSION SAAS ACTUAL CON',
    'Common.ssoEnabled': 'Habilitar SSO',
    'Common.sub_category': 'Sub-Categorias',
    'Common.tag': 'Etiqueta',
    'Common.tags': 'Etiquetas',
    'Common.team': 'Equipo',
    'Common.team_admins': 'Administrador de Equipo',
    'Common.time_period': 'Periodo',
    'Common.title': 'Titulo',
    'Common.today': 'Hoy!',
    'Common.total': 'Total',
    'Common.total_applications': 'Total e Aplicaciones',
    'Common.total_devices': 'Total de Dispositivos',
    'Common.total_users': 'Total de Usuarios',
    'Common.totalDevicesNotUsing': 'Dispositivos No Utilizando la Aplicación',
    'Common.totalDevicesUsing': 'Dispositivos Utilizando la Aplicación',
    'Common.unapproved': 'No Aprovado',
    'Common.unmanaged_applications': 'Aplicaciones No Gestionadas',
    'Common.unselected': 'No seleccionado',
    'Common.unsubscribe': 'Desuscribirse',
    'Common.update': 'Actualizar',
    'Common.updated': 'Actualizacion Exitosa!',
    'Common.url': 'URL',
    'Common.usage': 'Uso',
    'Common.usage_last_week': 'Uso la semana pasada',
    'Common.used': 'Sin uso',
    'Common.user': 'Usuario',
    'Common.user_count': 'Cantidad de Usuarios',
    'Common.users': 'Usuarios',
    'Common.using_application': 'Utilizando la Aplicación',
    'Common.utilities': 'Utilidades',
    'Common.version': 'Versión',
    'Common.view': 'Vista',
    'Common.website': 'Sitio Web',
    'Common.week': 'Semana ',
    'Common.yesterday': 'Ayer'
};
